export default "__VITE_ASSET__sHTVP8W9__"